import { db } from '@/plugins/firebase'
import { getDocs, collection, query, orderBy, limit, where, deleteDoc, doc } from 'firebase/firestore'
import { ActionContext } from 'vuex';
import moment from 'moment';
import { RootState } from '@/store/index';
import { Transcription, TranscriptionsState } from '@/models/models'

const state = {
  transcriptions: [],
};

const mutations = {
  setTranscriptions(state: TranscriptionsState, transcriptions: Transcription[]) {
    state.transcriptions = transcriptions;
  },
  removeTranscription(state: TranscriptionsState, transcriptionId: string) {
    state.transcriptions = state.transcriptions.filter(t => t.id !== transcriptionId);
  }
};

const actions = {
  async fetchTranscriptions({ commit }: ActionContext<TranscriptionsState, RootState>, uid: string) {
    const transcriptionsRef = collection(db, `users/${uid}/transcriptions`);
    const q = query(transcriptionsRef, orderBy('created_at', 'desc'), limit(1));
    const querySnapshot = await getDocs(q);

    const transcriptions: Transcription[] = querySnapshot.docs.map(doc => ({
      id: doc.id,
      created_at: moment(doc.data().created_at.toDate()).format('YYYY/MM/DD/H:mm:ss'),
      audio_file: doc.data().audio_file,
      download_url: doc.data().download_url,
      model: doc.data().model,
      messages: doc.data().messages,
      lesson_date: moment(doc.data().lesson_date.toDate()).format('YYYY/MM/DD'),
      note: doc.data().note,
    }));

    commit('setTranscriptions', transcriptions);
  },

  async fetchTranscriptionsByDate({ commit }: ActionContext<TranscriptionsState, RootState>, { uid, date }: { uid: string, date: string }) {
    const transcriptionsRef = collection(db, `users/${uid}/transcriptions`);
    const stardOfDay = moment(date, 'YYYY/MM/DD').startOf('day').toDate();
    const endOfDay = moment(date, 'YYYY/MM/DD').endOf('day').toDate();

    const q = query(transcriptionsRef,
      where('lesson_date', '>=', stardOfDay),
      where('lesson_date', '<', endOfDay));
    const querySnapshot = await getDocs(q);

    const transcriptions: Transcription[] = querySnapshot.docs.map(doc => ({
      id: doc.id,
      created_at: moment(doc.data().created_at.toDate()).format('YYYY/MM/DD/H:mm:ss'),
      audio_file: doc.data().audio_file,
      download_url: doc.data().download_url,
      model: doc.data().model,
      messages: doc.data().messages,
      lesson_date: moment(doc.data().lesson_date.toDate()).format('YYYY/MM/DD'),
      note: doc.data().note,
    }));

    commit('setTranscriptions', transcriptions);
  },

  async deleteTranscription({ commit }: ActionContext<TranscriptionsState, RootState>, { uid, transcriptionId }: { uid: string, transcriptionId: string }) {
    try {
      const transcriptionsRef = doc(db, `users/${uid}/transcriptions/${transcriptionId}`);
      await deleteDoc(transcriptionsRef);
      commit('removeTranscription', transcriptionId);
    } catch (error) {
      console.error('Error deleting transcription', error)
    }
  }
};

const getters = {
  transcriptions: (state: TranscriptionsState): Transcription[] => state.transcriptions,
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
